import React, {Component, useState} from 'react';
import {observer} from 'mobx-react';
import { Flex } from 'rebass';
import { REFUND_WAITLIST } from './results';
import { store } from '../mobx/store';
import { BTN_CLASS, CONFIRM_TX, PROCESSING_TX } from '../utils/constants';
import { VFlex } from './Flex';

interface RefundWaitlistPartProps {
}

const RefundWaitlistPart = observer((props:RefundWaitlistPartProps) => {
  const [isLoading, setIsLoading] = useState();
  const [message, setMessage] = useState();
  if (!REFUND_WAITLIST[store.web3Ctx?.account?.toLowerCase()]) return null;
  return (
    <VFlex>
      <Flex style={{alignItems: 'center', gap: 12}}>
        <h3 style={{marginTop: 9}}>Refund Waitlist Deposit:</h3>
        <div
          className={BTN_CLASS}
          onClick={async () => {
            if (store.isUserRefundedWaitlist || isLoading) return;
            setIsLoading(true);
            try {
              await store.waitlistContract.estimateGas.refund(REFUND_WAITLIST[store.web3Ctx.account.toLowerCase()]);
              setMessage(CONFIRM_TX);
              const res = await store.waitlistContract.refund(REFUND_WAITLIST[store.web3Ctx.account.toLowerCase()]);
              setMessage(PROCESSING_TX);
              await res.wait();
              store.isUserRefundedWaitlist = true;
              setMessage('Refund success!');
            } catch (error) {
              let m = store.getErrorMessageWithHeader(error);
              setMessage(`${m}`);
            }
            setIsLoading(false);
          }}
        >
          {(() => {
            if (isLoading) {
              return 'Loading...';
            }
            return store.isUserRefundedWaitlist ? 'REFUNDED' : 'REFUND';
          })()}
        </div>
        {
          (store.isUserRefundedWaitlist) && (
            <span>
              <img
                style={{transform: 'translateY(-1px)', marginLeft: 8}}
                src="/images/circle-tick.svg"
                alt=""
              />
            </span>
          )
        }
      </Flex>
      {
        message && (
          <div style={{color: message.startsWith('Error') && 'red'}}>
            {message}
          </div>
        )
      }
    </VFlex>
  );
});

export default RefundWaitlistPart;
